// Indian mobile numbers: 10 digits, first digit 6-9.
export const PHONE_REGEX = /^[6-9]\d{9}$/;

// Letters, spaces, apostrophes, hyphens — must start with a letter.
export const NAME_REGEX = /^[A-Za-z][A-Za-z\s'-]*$/;

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// At least 8 characters, one uppercase, one lowercase, one digit, one special character.
export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

// The backend stores phone numbers in E.164 form (e.g. "+919876543210"); the
// UI only ever collects the 10-digit national number, with +91 shown as a
// fixed prefix chip alongside it.
export function toIndianE164(nationalNumber: string): string {
  return `+91${nationalNumber}`;
}
